import helpers from "../helpers";

let carouselAvatar, carouselThumbnail, carouselLibraryEl;
helpers.addScript("https://www.youtube.com/iframe_api");
var youtubeEl,
  isUnMuted = false;

function onYouTubeIframeAPIReady() {
  youtubeEl = new YT.Player("jsYoutubePlayer", {
    width: "100%",
    videoId: "WCriHDs_MJs",
    autoplay: 0,
    events: {
      onReady: onPlayerReady,
    },
  });
}

function onPlayerReady(e) {
  e.target.stopVideo();
}

function youtubeInit() {
  onYouTubeIframeAPIReady();
}

function youtubePlay(id) {
  if (youtubeEl) {
    youtubeEl.loadVideoById(id);
    youtubeEl.playVideo();
  }
}

function youtubeStop() {
  if (youtubeEl) {
    youtubeEl.stopVideo();
  }
}

function renderSplide(carouselAvatarEl, carouselThumbEl, carouselImgEls) {
  if (carouselAvatarEl && carouselThumbEl) {
    carouselAvatar = new Splide("#" + carouselAvatarEl.id, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      rewind: false,
      autoplay: false,
      gap: "30px",
      speed: 500,
      loop: false,
      arrows: false,
      pagination: false,
    });

    carouselThumbnail = new Splide("#" + carouselThumbEl.id, {
      autoWidth: true,
      perMove: 1,
      autoplay: false,
      rewind: false,
      loop: false,
      gap: "5px",
      speed: 500,
      isNavigation: true,
      pagination: false,
    });

    carouselAvatar.mount();
    carouselAvatar.on("moved", function (newIndex) {
      carouselThumbnail.go(newIndex);
    });
    carouselThumbnail.on("moved", function (newIndex) {
      carouselAvatar.go(newIndex);
    });
    carouselThumbnail.mount();

    if (carouselImgEls) {
      let dataImgs = [],
        imgEls = carouselImgEls.querySelectorAll("img");
      if (imgEls.length > 0) {
        imgEls.forEach((imgEl) => {
          dataImgs.push({
            img: imgEl.src,
            ttl: imgEl.alt,
          });
        });
      } else if (carouselImgEls.dataset.imgs) {
        dataImgs = JSON.parse(carouselImgEls.dataset.imgs).datas;
      }
      if (dataImgs.length > 0) {
        dataImgs.forEach((dataImg, index) => {
          let avatarSlideEl = document.createElement("li"),
            avatarNameEl = document.createElement("span"),
            avatarItemEl = document.createElement("div"),
            avatarImgEl = document.createElement("img"),
            thumbSlideEl = document.createElement("li"),
            thumbItemEl = document.createElement("div"),
            thumbImgEl = document.createElement("img");
          avatarSlideEl.classList.add("splide__slide");
          avatarNameEl.classList.add("hc-carousel__name", "d-block");
          avatarNameEl.textContent = dataImg.ttl;
          avatarImgEl.src = dataImg.img;
          avatarImgEl.alt = dataImg.ttl;
          avatarItemEl.classList.add("hc-carousel__item", "position-relative");
          avatarItemEl.append(avatarImgEl);
          if (dataImg.ttl) {
            avatarItemEl.append(avatarNameEl);
          }
          avatarSlideEl.append(avatarItemEl);
          carouselAvatar.add(avatarSlideEl);
          thumbSlideEl.classList.add("splide__slide");
          thumbItemEl.classList.add("hc-carousel__item", "position-relative");
          thumbImgEl.classList.add("position-absolute");
          thumbImgEl.src = dataImg.img;
          thumbImgEl.alt = dataImg.ttl;
          thumbItemEl.append(thumbImgEl);
          thumbSlideEl.append(thumbItemEl);
          carouselThumbnail.add(thumbSlideEl);
          thumbItemEl.addEventListener("click", function () {
            carouselAvatar.go(index);
          });
        });
      }
    }
  }
}

function initSplide(carouselImgEls) {
  carouselLibraryEl = document.getElementById("jsCarouselLibrary");
  if (carouselLibraryEl) {
    let carouselAvatarEl = document.createElement("div"),
      carouselAvatarTrackEl = document.createElement("div"),
      carouselAvatarListEl = document.createElement("div"),
      carouselThumbEl = document.createElement("div"),
      carouselThumbTrackEl = document.createElement("div"),
      carouselThumbListEl = document.createElement("div"),
      carouselThumbArrowsEl = document.createElement("div"),
      carouselThumbPrevEl = document.createElement("div"),
      carouselThumbPrevImgEl = document.createElement("img"),
      carouselThumbNextEl = document.createElement("div"),
      carouselThumbNextImgEl = document.createElement("img");
    carouselAvatarEl.classList.add("hc-carousel__album", "splide");
    carouselAvatarEl.id = "jsCarouselAvatar";
    carouselAvatarEl.classList.add("show");
    carouselAvatarListEl.classList.add("splide__list");
    carouselAvatarTrackEl.classList.add("splide__track");
    carouselAvatarTrackEl.append(carouselAvatarListEl);
    carouselAvatarEl.append(carouselAvatarTrackEl);
    carouselLibraryEl.append(carouselAvatarEl);
    carouselThumbEl.classList.add(
      "hc-carousel__thumb",
      "d-inline-block",
      "splide"
    );
    carouselThumbEl.id = "jsCarouselThumbnail";
    carouselThumbEl.classList.add("show");
    carouselThumbListEl.classList.add("splide__list");
    carouselThumbTrackEl.classList.add("splide__track");
    carouselThumbTrackEl.append(carouselThumbListEl);
    carouselThumbEl.append(carouselThumbTrackEl);
    carouselThumbArrowsEl.classList.add("splide__arrows");
    carouselThumbPrevImgEl.height = 62;
    carouselThumbPrevImgEl.width = 31;
    carouselThumbPrevImgEl.src = "/assets/img/pro/icon/i-arrow-left.svg";
    carouselThumbPrevImgEl.atl = "image";
    carouselThumbNextImgEl.height = 62;
    carouselThumbNextImgEl.width = 31;
    carouselThumbNextImgEl.src = "/assets/img/pro/icon/i-arrow-right.svg";
    carouselThumbNextImgEl.atl = "image";
    carouselThumbPrevEl.append(carouselThumbPrevImgEl);
    carouselThumbPrevEl.classList.add("splide__arrow", "splide__arrow--prev");
    carouselThumbNextEl.append(carouselThumbNextImgEl);
    carouselThumbNextEl.classList.add("splide__arrow", "splide__arrow--next");
    carouselThumbArrowsEl.append(carouselThumbNextEl);
    carouselThumbArrowsEl.append(carouselThumbPrevEl);
    carouselThumbEl.append(carouselThumbArrowsEl);
    carouselLibraryEl.append(carouselThumbEl);
    renderSplide(carouselAvatarEl, carouselThumbEl, carouselImgEls);
  }
}

function removeAllSlide() {
  if (carouselAvatar != undefined && carouselThumbnail != undefined) {
    carouselAvatar.destroy();
    carouselThumbnail.destroy();
    carouselLibraryEl.innerHTML = "";
  }
}

function popupCall() {
  let popupCallEls = document.querySelectorAll(".jsPopupCall"),
    popupCloseEls = document.querySelectorAll(".jsPopupClose");
  if (popupCallEls) {
    popupCallEls.forEach((popupCallEl) => {
      popupCallEl.addEventListener("click", function (e) {
        e.preventDefault();
        let popupEl = document.getElementById(popupCallEl.dataset.popup);
        if (popupEl) {
          popupEl.classList.add("show");
          popupEl.addEventListener("click", function (e) {
            if (e.target.id == popupCallEl.dataset.popup) {
              popupEl.classList.remove("show");
              if (popupCallEl.dataset.popup == "popup-video") {
                youtubeStop();
              }
              if (popupCallEl.dataset.popup == "popup-library") {
                removeAllSlide();
              }
            }
          });
          if (popupCallEl.dataset.popup == "popup-video") {
            youtubePlay(popupCallEl.dataset.video);
          }
          if (popupCallEl.dataset.popup == "popup-library") {
            let carouselImgEls = popupCallEl.querySelector(".jsImgs");
            initSplide(carouselImgEls);
          }
        }
      });
    });
  }

  if (popupCloseEls.length > 0) {
    popupCloseEls.forEach((popupCloseEl) => {
      popupCloseEl.addEventListener("click", function () {
        popupCloseEl.closest(".jsPopup").classList.remove("show");
        if (popupCloseEl.closest("#popup-video") != null) {
          youtubeStop();
        }
        if (popupCloseEl.closest("#popup-library") != null) {
          removeAllSlide();
        }
      });
    });
  }
}

function showSpslide() {
  let splideEls = document.querySelectorAll(".splide");
  if (splideEls.length > 0) {
    splideEls.forEach((splideEl) => {
      splideEl.classList.add("show");
    });
  }
}

window.addEventListener("load", function () {
  showSpslide();
  youtubeInit();
  popupCall();

  function thumbClick(index, carouselDetail, thumbEls, thumbEl) {
    carouselDetail.go(index);
    helpers.removeCurrentClass(thumbEls);
    thumbEl.classList.add("current");
  }

  let carouselDetailEl = document.getElementById("jsCarouselDetail");
  if (carouselDetailEl) {
    const carouselDetail = new Splide(carouselDetailEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      autoplay: false,
      gap: "30px",
      speed: 1000,
      pagination: false,
      arrows: true,
    });
    carouselDetail.mount();
    let thumbEls = document.querySelectorAll(".jsThumb");
    if (thumbEls.length > 0) {
      thumbEls.forEach((thumbEl, index) => {
        thumbEl.addEventListener("click", function () {
          thumbClick(index, carouselDetail, thumbEls, thumbEl);
        });
      });
    }
    carouselDetail.on("moved", function (e) {
      thumbEls.forEach((thumbEl, index) => {
        if (carouselDetail.index == index) {
          helpers.removeCurrentClass(thumbEls);
          thumbEl.classList.add("current");
        }
      });
    });
  }

  let carouselRelatedEls = document.querySelectorAll(".jsCarouselRelated");
  if (carouselRelatedEls.length > 0) {
    carouselRelatedEls.forEach((carouselRelatedEl) => {
      const carouselRelated = new Splide(carouselRelatedEl, {
        autoWidth: false,
        perMove: 1,
        perPage: 4,
        autoplay: false,
        gap: "30px",
        speed: 500,
        arrows: false,
        pagination: true,
        breakpoints: {
          1199: {
            gap: "10px",
            perPage: 2,
          },
          767: {
            gap: "10px",
            perPage: 1,
          },
        },
      });
      carouselRelated.mount();
    });
  }

  let carouselBlogRelatedEl = document.getElementById("jsCarouselBlogRelated");
  if (carouselBlogRelatedEl) {
    const carouselBlogRelated = new Splide(carouselBlogRelatedEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 3,
      autoplay: false,
      gap: "30px",
      speed: 500,
      arrows: false,
      pagination: true,
      breakpoints: {
        1199: {
          gap: "10px",
          perPage: 2,
        },
        767: {
          gap: "10px",
          perPage: 1,
        },
      },
    });
    carouselBlogRelated.mount();
  }

  let carouselBannerEl = document.getElementById("jsCarouselBanner");
  if (carouselBannerEl) {
    const carouselBanner = new Splide(carouselBannerEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      autoplay: true,
      type: "fade",
      gap: "30px",
      speed: 1000,
      pagination: true,
      arrows: false,
      breakpoints: {
        767: {
          arrows: true,
          pagination: false,
        },
      },
    });
    carouselBanner.mount();
  }

  let carouselProjectEl = document.getElementById("jsCarouselProject");
  if (carouselProjectEl) {
    let carouselProject = new Splide(carouselProjectEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      autoplay: false,
      gap: "30px",
      speed: 1000,
      pagination: true,
      arrows: false,
      breakpoints: {
        1023: {
          arrows: true,
          pagination: false,
        },
      },
    });
    carouselProject.mount();
  }

  let carouselVideoEl = document.getElementById("jsCarouselVideo");
  if (carouselVideoEl) {
    const carouselVideo = new Splide(carouselVideoEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      autoplay: false,
      gap: "30px",
      speed: 1000,
      arrows: false,
      pagination: true,
      breakpoints: {
        767: {
          arrows: true,
          pagination: false,
        },
      },
    });
    carouselVideo.mount();
  }

  let carouselPictureEl = document.getElementById("jsCarouselPicture");
  if (carouselPictureEl) {
    const carouselPicture = new Splide(carouselPictureEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      autoplay: false,
      gap: "30px",
      speed: 1000,
      arrows: false,
      pagination: true,
      breakpoints: {
        767: {
          arrows: true,
          pagination: false,
        },
      },
    });
    carouselPicture.mount();
  }

  let carouselCourseEl = document.getElementById("jsCarouselCourse");
  if (carouselCourseEl) {
    const carouselCourse = new Splide(carouselCourseEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 1,
      autoplay: false,
      gap: "30px",
      speed: 1000,
      arrows: false,
      pagination: true,
    });
    carouselCourse.mount();
  }

  let carouselProductEl = document.getElementById("jsCarouselProduct");
  if (carouselProductEl) {
    const carouselProduct = new Splide(carouselProductEl, {
      autoWidth: false,
      perMove: 1,
      perPage: 4,
      autoplay: false,
      gap: "30px",
      speed: 1000,
      arrows: false,
      pagination: true,
      breakpoints: {
        1199: {
          perPage: 3,
          gap: "15px",
        },
        767: {
          perPage: 2,
          gap: "15px",
          arrows: true,
          pagination: false,
        },
      },
    });
    carouselProduct.mount();
  }

  let carouselFeedbackEl = document.getElementById("jsCarouselFeedback");
  if (carouselFeedbackEl) {
    let carouselFeedback = new Splide(carouselFeedbackEl, {
      autoWidth: false,
      type: "loop",
      perMove: 1,
      perPage: 2,
      focus: "center",
      autoplay: false,
      gap: "30px",
      speed: 500,
      pagination: true,
      arrows: false,
      breakpoints: {
        767: {
          perPage: 1,
          gap: "15px",
          arrows: true,
          pagination: false,
        },
      },
    });
    carouselFeedback.mount();
  }
});
